<template>
  <div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="order-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5
              class="modal-title text-white text-bold"
              v-if="selectedIndex == null"
            >
              Create New Order
            </h5>
            <h5 class="modal-title text-white text-bold" v-else>Edit Order</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="row">
              <div class="col-md-6 mb-20">
                <label
                  >Item Name
                  <small class="text-danger" v-if="errors.item_name"
                    >* Required</small
                  ></label
                >
                <item-select v-model="params.item_name" />
              </div>
              <div class="col-md-6 mb-20">
                <label
                  >Amount
                  <small class="text-danger" v-if="errors.amount"
                    >* Required</small
                  ></label
                >
                <input
                  type="number"
                  v-model="params.amount"
                  class="form-control form-custom"
                  placeholder="0"
                />
              </div>
              <div class="col-md-6 mb-20">
                <label>Select Fabric</label>
                <fabric-select v-model="params.fabrics" />
              </div>
              <div class="col-md-6 mb-20">
                <label>Urgent</label>
                <toggle-button :sync="true" v-model="params.urgent" />
              </div>
              <div class="col-md-12">
                <label for="">Comment</label>
                <textarea
                  class="form-control"
                  v-model="params.comments[0].text"
                  rows="3"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-if="selectedIndex == null"
              @click="save"
            >
              Save
            </button>
            <button type="button" class="btn btn-primary" v-else @click="save">
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItemSelect from "./ItemSelect";
import FabricSelect from "./FabricSelect";
export default {
  props: ["params", "selectedIndex"],

  components: {
    ItemSelect,
    FabricSelect,
  },

  data() {
    return {
      errors: {},
    };
  },

  methods: {
    save() {
      this.errors = {};
      if (!this.params.item_name) {
        this.errors.item_name = true;
      }
      if (!this.params.amount) {
        this.errors.amount = true;
      }
      if (ezy.objectLength(this.errors) === 0) {
        this.$emit("submit", true);
      }
    },
  },
};
</script>

<style scoped>
.form-custom {
  height: 42px !important;
  border: 1px solid #cdcdcd !important;
}
</style>
